export default __webpack_public_path__ + "static/media/poster-04.85f38847.png";